import { isAfter } from 'date-fns';
import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
import { EventsListUiComponentInterface, UiComponentElementInterface } from '../../../../../../interfaces/pagebuilder';
import { fetchAndSetTeamEvents } from '../../../../../../reduxToolkit/slices/commonSlice';
import { useSelector, useDispatch } from '../../../../../../reduxToolkit/typedRedux';
import EmptyComponent from '../../../../pageBuilder/EmptyComponent';
import EventsListItem from './EventsListItem';

const EventsListUiComponent = ({ uiComponent }: UiComponentElementInterface<EventsListUiComponentInterface>) => {
  const teamEvents = useSelector(({ common }) => common.teamEvents);
  const teamName = useSelector(({ common }) => common.teamName);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (teamEvents !== undefined) return;
    if (!teamName) return;
    dispatch(fetchAndSetTeamEvents(teamName));
  }, [teamEvents, teamName]);

  const _filteredTeamEvents = teamEvents
    ? teamEvents
        .filter((e) => uiComponent?.selectAllEvents || uiComponent?.eventsList.includes(e._id))
        .filter((e) => !uiComponent?.hidePastEvents || isAfter(new Date(e.datetime_end), new Date()))
    : [];

  return (
    <>
      {_filteredTeamEvents.length > 0 && (
        <div
          className={`w-full overflow-hidden flex flex-col space-y-2`}
          style={{
            color: uiComponent?.styling?.textColor || '#000',
          }}>
          {_filteredTeamEvents.map((e) => (
            <EventsListItem
              event={e}
              textColor={uiComponent?.customStyling.buttonTextColor ?? uiComponent?.styling.textColor}
              buttonColor={uiComponent?.customStyling.buttonColor}
              buttonText={uiComponent?.openBtnText}
              showEndTime={uiComponent?.showEventEndTime}
            />
          ))}
        </div>
      )}
      {_filteredTeamEvents.length === 0 && (
        <>
          <EmptyComponent componentName={t('pagebuilder:events-list-title')} />
        </>
      )}
    </>
  );
};

export default EventsListUiComponent;
